import script from "./ManualStart.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualStart.vue?vue&type=script&setup=true&lang=js"

import "./ManualStart.vue?vue&type=style&index=0&id=7190d80b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7190d80b"]])

export default __exports__